import {
  FETCH_SPECIALTYDETAILS_REQUEST,
  FETCH_SPECIALTYDETAILS_SUCCESS,
  FETCH_SPECIALTYDETAILS_ERROR,
  FETCH_SPECIALTIES_REQUEST,
  FETCH_SPECIALTIES_SUCCESS,
  FETCH_SPECIALTIES_ERROR,
  UNFOLLOW_SPECIALTY_REQUEST,
  UNFOLLOW_SPECIALTY_SUCCESS,
  UNFOLLOW_SPECIALTY_ERROR,
  FOLLOW_SPECIALTY_REQUEST,
  FOLLOW_SPECIALTY_SUCCESS,
  FOLLOW_SPECIALTY_ERROR,
  CLEAR_SPECIALTY_DETAILS,
} from "../actionTypes";

export const initialState = {
  isFetching: false,
  hasError: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SPECIALTYDETAILS_REQUEST:
      return {
        ...state,
        isFetching: true,
        hasError: false,
      };
    case FETCH_SPECIALTYDETAILS_SUCCESS:
      const specialities = {
        ...state,
        isFetching: false,
      };
      specialities.specialtyDetails = { ...action.payload.viewModel };
      return specialities;
    case FETCH_SPECIALTYDETAILS_ERROR:
      return {
        ...state,
        isFetching: false,
        hasError: true,
      };
    case FETCH_SPECIALTIES_REQUEST:
      return {
        ...state,
        isFetching: true,
        hasError: false,
      };
    case FETCH_SPECIALTIES_SUCCESS:
      return {
        ...state,
        specialtiesList: { ...action.payload.viewModel },
        isFetching: false,
      };
    case FETCH_SPECIALTIES_ERROR:
      return {
        ...state,
        isFetching: false,
        hasError: true,
      };
    case FOLLOW_SPECIALTY_REQUEST:
    case UNFOLLOW_SPECIALTY_REQUEST:
      return {
        ...state,
        isFetching: false,
        hasError: false,
      };
    case FOLLOW_SPECIALTY_SUCCESS:
    case UNFOLLOW_SPECIALTY_SUCCESS:
      const newState = { ...state, isFetching: false };
      const { specialtyDetails, specialtiesList } = newState;
      const { followData } = action.payload.response;
      const { isOnSpecialtyDetails } = action.payload;

      if (isOnSpecialtyDetails) {
        specialtyDetails.followData = { ...followData };
      }

      if (specialtiesList) {
        specialtiesList.specialties = specialtiesList.specialties.map(
          (specialty) =>
            specialty.followData.functionArgs.specialtyId ===
            followData.functionArgs.specialtyId
              ? { ...specialty, followData }
              : specialty
        );
      }

      return newState;
    case FOLLOW_SPECIALTY_ERROR:
    case UNFOLLOW_SPECIALTY_ERROR:
      return {
        ...state,
        isFetching: false,
        specialtyFollowError: { ...action.payload },
      };

    case CLEAR_SPECIALTY_DETAILS:
      return {
        ...state,
        specialtyDetails: null,
      };

    default:
      return { ...state };
  }
};
